import { Container } from '@mui/material';
import './About.scss';

const About = () => {
    return (
        <Container className="spacer">
            <div id="bio">
                <p>
                    I’m a multidisciplinary creative based in NYC. Some of the things I do include software engineering, digital design, and film photography.
                    When I’m not working at <a href="https://nytimes.com/" target="_blank" rel="noopener noreferrer"><span>The New York Times</span></a>,
                    I can be found somewhere running, taking pictures, or in a café working on a side project.
                </p>
            </div>
        </Container>
    )
}

export default About;